// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30_mZ","colBig":"styles_colBig__26xgA","colSmall":"styles_colSmall__3Rcwj"};